import Hero from '../components/sections/Hero';
import ValueProposition from '../components/sections/ValueProposition';
import Services from '../components/sections/Services';
import CrossSelling from '../components/sections/CrossSelling';
import SocialProof from '../components/sections/SocialProof';

const HomePage = () => {
  return (
    <>
      <Hero />
      <ValueProposition />
      <Services />
      <CrossSelling />
      <SocialProof />
    </>
  );
};

export default HomePage;
